import { DomainSheet } from "@/components/domain";
import { createFileRoute } from "@tanstack/react-router";
import { CalendarView } from ".";
import { ReservationFulfillments } from "../$id.fulfillments";

export const Route = createFileRoute(
  "/(reservations)/reservations/calendar/$id/fulfillments",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const navigate = Route.useNavigate();

  return (
    <>
      <CalendarView />
      <DomainSheet
        noOutlet
        onClose={() => {
          navigate({ to: "/reservations/calendar" });
        }}
      >
        <ReservationFulfillments id={id} />
      </DomainSheet>
    </>
  );
}
